module.exports = __webpack_public_path__ + "img/4.f2d4f317.png";